<script setup lang="ts">
import type { CmsElementPluebelCmsElementsBeforeAfterBox } from "~/composables/useCustom";
import { useCmsElementConfig } from "#imports";
import { ProductDetailBeforeAfterBoxItem } from "#components";

const props = defineProps<{
  content: CmsElementPluebelCmsElementsBeforeAfterBox;
}>();

const { getConfigValue } = useCmsElementConfig(props.content);

const boxes = computed(() => getConfigValue("before_after_box"));

const config: ComputedRef<SliderElementConfig> = computed(() => ({
  minHeight: {
    value: "300px",
    source: "static",
  },
  displayMode: {
    value: "contain",
    source: "static",
  },
  navigationDots: {
    value: "",
    source: "static",
  },
}));

const slidesToShow = ref<number>(4);

const updateSlidesToShow = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 640) {
    slidesToShow.value = 1;
  } else if (screenWidth < 1024) {
    slidesToShow.value = 2;
  } else if (screenWidth < 1480) {
    slidesToShow.value = 3;
  } else {
    slidesToShow.value = 4;
  }
};

onMounted(() => {
  setTimeout(() => {
    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
  }, 200);
});

const beforeAfterBoxesSlider = ref(null);

const beforeAfterBoxesSwiperSlider = useSwiper(beforeAfterBoxesSlider, {
  effect: "slide",
  loop: true,
  grabCursor: true,
  slidesPerView: 4,
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});
</script>
<template>
  <section class="pb-10 md:pb-14 lg:pb-20">
    <div class="container">
      <div class="tab-slider cat-slider-04 md:-mx-2 lg:-mx-4">
        <swiper-container
          ref="beforeAfterBoxesSlider"
        >
          <swiper-slide v-for="box in boxes" :key="box.headline">
            <ProductDetailBeforeAfterBoxItem :box="box" />
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
  </section>
</template>
